// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__3KT_A","label":"Section_label__1W-Pr","contentWrap":"Section_contentWrap__1gDS3","footer":"Section_footer__eXD5L","footerInner":"Section_footerInner__1JkOl"};